import { useCallback, useMemo } from 'react';
import { LanguageEnum, getLanguage } from './const';
import { SelectProps } from 'antd';

interface UseOptionsProps {
    /** 是否展示‘所有语言’这一类型，注意，区别于‘全部’ */
    hasAll?: boolean;
    disabledList?: number[];
    disabledAllListWithoutChecked?: boolean;
    checkedList?: number[];
    overrideList?: number[];
    options?: SelectProps<number>['options'];
}

export const useOptions = (props?: UseOptionsProps) => {
    const {
        hasAll,
        disabledList,
        disabledAllListWithoutChecked,
        checkedList,
        overrideList,
        options: _options,
    } = props || {};

    const getOption = useCallback(
        (lang: number) => {
            return {
                value: lang,
                label: getLanguage(lang),
                // disabled 的逻辑：在 disabledList 中，或者，全部 disbaled 但不在 checkedList 中
                disabled:
                    disabledList?.includes(lang) ||
                    (disabledAllListWithoutChecked && !checkedList?.includes(lang)),
            };
        },
        [checkedList, disabledAllListWithoutChecked, disabledList]
    );

    const { options } = useMemo(() => {
        let options: SelectProps<number>['options'] = [
            getOption(LanguageEnum.ZH),
            getOption(LanguageEnum.EN),
            getOption(LanguageEnum.ID),
            getOption(LanguageEnum.VI),
            getOption(LanguageEnum.MS),
            getOption(LanguageEnum.FI),
            getOption(LanguageEnum.TI),
            getOption(LanguageEnum.SP),
            getOption(LanguageEnum.PT),
            getOption(LanguageEnum.FR),
            getOption(LanguageEnum.DE),
            getOption(LanguageEnum.KR),
            getOption(LanguageEnum.JP),
            getOption(LanguageEnum.ZH_HK),
            getOption(LanguageEnum.KM),
            getOption(LanguageEnum.AR),
            getOption(LanguageEnum.RU),
            getOption(LanguageEnum.TU),
            getOption(LanguageEnum.IT),
            getOption(LanguageEnum.GR),
            getOption(LanguageEnum.FIL),
            getOption(LanguageEnum.PL),
            getOption(LanguageEnum.HL),
            getOption(LanguageEnum.JT),
            getOption(LanguageEnum.KK),
            getOption(LanguageEnum.UR),
        ];

        if (hasAll) {
            options = [getOption(LanguageEnum.All), ...options];
        }

        if (overrideList?.length) {
            options = overrideList.map(getOption);
        }

        if (_options) {
            options = _options;
        }

        return {
            options,
        };
    }, [_options, getOption, hasAll, overrideList]);

    return {
        options,
    };
};
